export const amenitiesSrc: { [key: string]: string } = {
    "air-conditioning": "https://d292awxalydr86.cloudfront.net/Amenities+icons/Aircon.svg",
    "dining-area": "https://d292awxalydr86.cloudfront.net/Amenities+icons/Dining+table.svg",
    "kitchen": "https://d292awxalydr86.cloudfront.net/Amenities+icons/Kitchen.svg",
    "microwave": "https://d292awxalydr86.cloudfront.net/Amenities+icons/Microwave.svg",
    "private-bathroom": "https://d292awxalydr86.cloudfront.net/Amenities+icons/Bathtub.svg",
    "towels": "https://d292awxalydr86.cloudfront.net/Amenities+icons/Linen.svg",
    "tv": "https://d292awxalydr86.cloudfront.net/Amenities+icons/Television.svg",
    "wi-fi": "https://d292awxalydr86.cloudfront.net/Amenities+icons/Wifi.svg",
    "coffee-maker": "https://d292awxalydr86.cloudfront.net/Amenities+icons/coffee-maker.svg",
    "dishwasher": "https://d292awxalydr86.cloudfront.net/Amenities+icons/dishwasher.svg",
    "fridge": "https://d292awxalydr86.cloudfront.net/Amenities+icons/fridge.svg",
    "oven": "https://d292awxalydr86.cloudfront.net/Amenities+icons/oven.svg",
    "stove": "https://d292awxalydr86.cloudfront.net/Amenities+icons/stove.svg",
    "toaster": "https://d292awxalydr86.cloudfront.net/Amenities+icons/toaster.svg",
    "workspace": "https://d292awxalydr86.cloudfront.net/Amenities+icons/workspace.svg",
    "wardrobe": "https://d292awxalydr86.cloudfront.net/Amenities+icons/wardrobe.svg",
    "bed": "https://d292awxalydr86.cloudfront.net/Listing+page+icons/Bedrooms.svg",
    "desk": "https://d292awxalydr86.cloudfront.net/Amenities+icons/Desk.svg",
    "washer": "https://d292awxalydr86.cloudfront.net/Amenities+icons/Washer.svg",
    "heating": "https://d292awxalydr86.cloudfront.net/Amenities+icons/Heating.svg",
    "pots-and-pans": "https://d292awxalydr86.cloudfront.net/Amenities+icons/pots+and+pans.svg",
    "pool": "https://d292awxalydr86.cloudfront.net/Amenities+icons/Pool.svg",
    "bedding": "https://d292awxalydr86.cloudfront.net/Amenities+icons/hotel+bed.png",
    "iron": "https://d292awxalydr86.cloudfront.net/Amenities+icons/Iron.svg",
    "safe": "https://d292awxalydr86.cloudfront.net/Amenities+icons/Safe.svg",
    "lift": "https://d292awxalydr86.cloudfront.net/Amenities+icons/Lift.svg",
    "dryer": "https://d292awxalydr86.cloudfront.net/Amenities+icons/Dryer.svg",
    "gym": "https://d292awxalydr86.cloudfront.net/Amenities+icons/Gym.svg",
    "bbq": "https://d292awxalydr86.cloudfront.net/Amenities+icons/BBQ.svg",
    "hair-dryer": "https://d292awxalydr86.cloudfront.net/Amenities+icons/Hair+dryer.svg",
    "spa": "https://d292awxalydr86.cloudfront.net/Amenities+icons/Spa.svg",
    "office": "https://d292awxalydr86.cloudfront.net/Amenities+icons/Office.svg",
    "free-parking": "https://d292awxalydr86.cloudfront.net/Amenities+icons/Parking.svg",
    "linen": "https://d292awxalydr86.cloudfront.net/Amenities+icons/Linen.svg",
    "paid-parking": "https://d292awxalydr86.cloudfront.net/Amenities+icons/Parking.svg",
    "street-parking": "https://d292awxalydr86.cloudfront.net/Amenities+icons/Parking.svg",
    "valet-parking": "https://d292awxalydr86.cloudfront.net/Amenities+icons/Parking.svg",
    "balcony": "https://d292awxalydr86.cloudfront.net/Amenities+icons/balcony.svg",
    "bath": "https://d292awxalydr86.cloudfront.net/Amenities+icons/bath.svg",
    "shower": "https://d292awxalydr86.cloudfront.net/Amenities+icons/shower.svg",
    "toiletries": "https://d292awxalydr86.cloudfront.net/Amenities+icons/toiletries.svg",
    default: "https://d292awxalydr86.cloudfront.net/Amenities+icons/default.svg"
};